import React from "react";
import { ExternalLink, Send } from "lucide-react";
import { DISCORD_LINK, LOGO_URL, PATREON_LINK, SOCIAL_LINKS, SUPPORT_EMAIL, WHATSAPP_LINK } from "@/constants";

// Custom SVG icons for social media
const YoutubeIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

const FacebookIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const TwitterIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);

const PatreonIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M15.386.524c-4.764 0-8.64 3.876-8.64 8.64 0 4.75 3.876 8.613 8.64 8.613 4.75 0 8.614-3.864 8.614-8.613C24 4.4 20.136.524 15.386.524M.003 23.537h4.22V.524H.003"/>
  </svg>
);

const WhatsAppIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347M12.057 21.785h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.999-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.002-5.45 4.436-9.884 9.889-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.887 9.884M20.472 3.488A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.946L.057 24l6.304-1.654a11.882 11.882 0 0 0 5.69 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.477-8.413"/>
  </svg>
);

const Footer = () => {
  const socialLinks = [
    { icon: WhatsAppIcon, href: SOCIAL_LINKS.whatsapp, label: "WhatsApp" },
    { icon: YoutubeIcon, href: SOCIAL_LINKS.youtube, label: "YouTube" },
    { icon: PatreonIcon, href: SOCIAL_LINKS.patreon, label: "Patreon" },
    { icon: FacebookIcon, href: SOCIAL_LINKS.facebook, label: "Facebook" },
    { icon: TwitterIcon, href: SOCIAL_LINKS.twitter, label: "Twitter/X" },
    { icon: InstagramIcon, href: SOCIAL_LINKS.instagram, label: "Instagram" },
  ];

  return (
    <footer data-testid="footer" className="bg-ics-navy border-t border-white/5 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top Section */}
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8 mb-8">
          {/* Logo */}
          <a href="#home" className="flex items-center">
            <img
              src={LOGO_URL}
              alt="Investment Circle Shariah"
              className="h-16 md:h-20 w-auto"
            />
          </a>

          {/* Social Media Links */}
          <div className="flex flex-col items-center gap-3">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-ics-gray">
              Follow ICS
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-social-${social.label.toLowerCase().replace('/', '-')}`}
                className="w-10 h-10 rounded-full bg-white/5 hover:bg-ics-orange/20 flex items-center justify-center transition-colors group"
                title={social.label}
                aria-label={social.label}
              >
                <span className="text-ics-gray group-hover:text-ics-orange transition-colors">
                  <social.icon />
                </span>
              </a>
            ))}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-3">
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/10 bg-white/5 px-5 py-2.5 text-sm font-semibold text-ics-white transition-all duration-300 hover:border-green-400/30 hover:bg-green-500/10"
            >
              WhatsApp
              <Send className="w-4 h-4" />
            </a>
            <a
              href={PATREON_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-patreon-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-ics-orange/40 bg-ics-orange/10 px-5 py-2.5 text-sm font-semibold text-ics-white transition-all duration-300 hover:bg-ics-orange/20"
            >
              Patreon
              <ExternalLink className="w-4 h-4" />
            </a>
            <a
              href={DISCORD_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-discord-btn"
              className="inline-flex items-center justify-center gap-2 bg-ics-orange hover:bg-ics-orange-hover text-white font-semibold px-5 py-2.5 rounded-full transition-all duration-300 text-sm"
            >
              Join Discord
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-white/5 pt-8">
          <p className="text-xs text-ics-gray text-center max-w-3xl mx-auto mb-4">
            ICS (Investment Circle Shariah) is an informal research community. We are not a regulated 
            entity, not financial advisors, and do not provide individualized investment recommendations.
          </p>
          
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-xs text-ics-gray">
            <span>&copy; {new Date().getFullYear()} Investment Circle Shariah. All rights reserved.</span>
            <span className="hidden md:inline">•</span>
            <a href={`mailto:${SUPPORT_EMAIL}`} className="hover:text-ics-orange transition-colors">
              {SUPPORT_EMAIL}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
